import React from "react";
import { TextField } from "@mui/material";

const FormField = ({
  id,
  name,
  label,
  type = "text",
  value,
  error,
  helperText,
  onChange,
  onBlur,
  readOnly = false,
  inputProps,
  slotProps,
}) => {
  return (
    <TextField
      id={id}
      name={name}
      label={label}
      variant="outlined"
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      fullWidth
      error={error}
      helperText={helperText}
      autoComplete="off"
      size="medium"
      slotProps={{
        input: {
          readOnly,
          ...slotProps?.input,
        },
        inputLabel: slotProps?.inputLabel,
        ...slotProps,
      }}
      inputProps={inputProps}
    />
  );
};

export default FormField;
